import axios from "axios";
export default {
  namespaced: true,
  state: {
    positions: [],
  },
  getters: {
    positions(state) {
      return state.positions;
    },
  },
  mutations: {
    SET_POSITIONS(state, positions) {
      state.positions = positions;
    },
    ADD_POSITION(state, position) {
      state.positions.unshift(position);
    },
    EDIT_POSITION(state, position) {
      var index = state.positions.findIndex((a) => a.id == position.id);
      state.positions.splice(index, 1, position);
    },
    DELETE_POSITION(state, position) {
      let filtered = state.positions.filter((c) => {
        return c.id != position.id;
      });
      state.positions = filtered;
    },
  },
  actions: {
    // get positions
    async get_positions({ commit }) {
      let response = await axios.get("/positions");
      commit("SET_POSITIONS", response.data);
    },
    async add_position({ commit }, request) {
      let response = await axios.post("/position", request);
      commit("ADD_POSITION", response.data);
    },
    async edit_position({ commit }, request) {
      let response = await axios.put("/position", request);
      commit("EDIT_POSITION", response.data);
    },
    async delete_position({ commit }, request) {
      await axios.delete("/position/" + request.id);
      commit("DELETE_POSITION", request);
    },
  },
};
